// laravel passport

import { PbxHttpClient } from "@/services/httpclient";

const state = {
  roles: [],
};

const getters = {
  BY_ID: (state) => (id) => {
    const value = state.roles.find((element) => {
      return element.id === payload.id;
    });
    if (value === undefined) {
      return value;
    } else {
      return "";
    }
  },
};

const mutations = {
  PUSH_ROLE: (state, payload) => {
    const value = state.roles.find((element) => {
      return element.id === payload.id;
    });
    if (value === undefined) {
      state.roles.push(payload);
    }
  },

  UPDATE_ROLE: (state, payload) => {
    const indexupdate = state.roles
      .map((element) => {
        return element.id;
      })
      .indexOf(payload.id);
    if (indexdelete > -1) {
      state.roles.splice(indexupdate, 1, payload);
    }
  },

  DELETE_ROLE: (state, payload) => {
    const indexdelete = state.roles
      .map((element) => {
        return element.id;
      })
      .indexOf(payload);
    if (indexdelete > -1) {
      state.roles.splice(indexdelete, 1);
    }
  },

  REPLACE_ROLES: (state, payload) => {
    state.roles = payload;
  },
};

const actions = {
  async GET_ROLES({ state, commit }) {
    try {
      const res = await PbxHttpClient.get(`/roles/`);
      commit("REPLACE_ROLES", res.data);
      return;
    } catch (error) {
      // console.log(error);
      return Promise.reject();
    }
  },

  async CREATE_ROLE({ state, commit }, payload) {
    try {
      const res = await PbxHttpClient.post(`/roles/`, payload);
      commit("PUSH_ROLE", res.data);
      return;
    } catch (error) {
      // console.log(error);
      return Promise.reject();
    }
  },

  async UPDATE_ROLE({ state, commit }, payload) {
    try {
      const res = await PbxHttpClient.put(`/roles/${payload.id}`, payload);
      commit("UPDATE_ROLE", res.data);
      return;
    } catch (error) {
      // console.log(error);
      return Promise.reject();
    }
  },

  async DELETE_ROLE({ state, commit }, payload) {
    try {
      const res = await PbxHttpClient.delete(`/roles/${payload}`);
      commit("DELETE_ROLE", payload);
      return;
    } catch (error) {
      // console.log(error);
      return Promise.reject();
    }
  },
};

// exportar propiedades
export const role = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
